enum FacebookPixelCustomEventName {
  FIRST_SIGNING_REQUEST_COMPLETED = 'FirstSigningRequestCompleted',
  SIGN_UP = 'SignUp',
}

export default FacebookPixelCustomEventName;
